import Notice from 'pages/admin/contents/notice';
import React, {useEffect, useState} from 'react';
import Api from "../../../../interface/api/content"
import { FaqInfoDTO } from '../../../../interface/model/board';

export default function Faq() {
    const siteInfo = JSON.parse(localStorage.getItem('siteInfo'));
    const [ faqInfos, setFaqInfos ] = useState<Array<FaqInfoDTO>>([]);

    const [answerOnOff, setAnswerOnOff] = useState({
        seq : 0,
        flag : false
    });

    function answerHandler(key) {
        setAnswerOnOff({seq : key.seq, flag : !answerOnOff.flag});
    }

    useEffect(() => {
        Api.getBoardInfos("FAQ", siteInfo.seq).then(res => setFaqInfos(res.data));
    }, [])

    return (
        <div className={'nv_contents'}>
            <h2 className="nv_subtit">FAQ</h2>
            <div className="nv_board_notice">
                <div className="nv_tablebox">
                    <div className="board_search_area">
                        <div className="nv_select_box">
                            <p>제목+내용</p>
                            <ul className="nv_select">
                                <li>제목+내용</li>
                                <li>제목</li>
                                <li>내용</li>
                            </ul>
                        </div>
                        <div className="board_search_input">
                            <input type="text" className="nv_input" />
                            <input type="submit" className="search_icon" />
                        </div>
                    </div>
                    <table className="nv_table textcenter faq">
                        <thead>
                            <tr>
                                <th scope="row" className="num">No.</th>
                                <th scope="row" className="title">제목</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                faqInfos.map((faqInfo, index) => (
                                    <>
                                        <tr key={`faqInfoKey-Q-${index}`} className="tr_q" onClick={() => answerHandler(faqInfo)}>
                                            <td className="icon">질문</td>
                                            <td className="textleft">{faqInfo.title}</td>
                                        </tr>
                                        {
                                            (faqInfo.seq === answerOnOff.seq && answerOnOff.flag === true) ?
                                            <tr key={`faqInfoKey-A-${index}`} className="tr_a on">
                                                <td>답변</td>
                                                <td className="textleft" dangerouslySetInnerHTML={ {__html: faqInfo.contents} }></td>
                                            </tr> : ''
                                        }
                                    </>
                                ))
                            }
                        </tbody>
                    </table>
                    <div className="pagenum_area">
                        <ul>
                            <li className="first">fisrt</li>
                            <li className="prev">prev</li>
                            <li className="on">1</li>
                            {/*<li>2</li>*/}
                            {/*<li>3</li>*/}
                            {/*<li>4</li>*/}
                            {/*<li>5</li>*/}
                            {/*<li>6</li>*/}
                            {/*<li>7</li>*/}
                            {/*<li>8</li>*/}
                            {/*<li>9</li>*/}
                            {/*<li>0</li>*/}
                            <li className="next">next</li>
                            <li className="last">last</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}